import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  LoginModel,
  Stations,
  Stores,
  TpmLicenseModel,
  UserPermissionsModel,
} from '../../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../../Services/master-data-serive.service';
import { CustomToastsService } from '../../../../Services/custom-toasts.service';
import { ExportExcelService } from '../../../../Services/export-excel.service';
import { AdminBreadcrumbsService } from '../../admin-services/admin-breadcrumbs.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ImportServiceService } from '../../../../Services/import-service.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserserviceService } from 'src/app/Services/userservice.service';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'app-stations',
  templateUrl: './stations.component.html',
  styleUrls: ['./stations.component.css'],
})
export class StationsComponent {
  activeStatus: boolean = false;
  activeColor: string = '#1e5a7d';
  inActiveColor: string = '#aab6bc';
  stationslist: Array<Stations> = [];
  stationsData: Stations = new Stations();
  stores: Array<Stores> = [];
  headerCheckboxSelected: boolean = false;
  deleteParameter: any = null; // Initialize with a default value
  deleteButtonClickedWithoutSelection: boolean = false;
  deleteButtonClickedWithSelection: boolean = false;
  isUpdated = false;
  selectedStationIds: string[] = [];
  exportList: any = [];
  frmText: string = 'Add New Station';
  StationsArray: Array<Stations> = [];
  StationsArray1: Array<Stations> = [];
  StationsArrayforFilter: Array<Stations> = [];
  ArrayForStations: Array<Stations> = [];
  noData: boolean = false;
  filterName: string = 'store';
  filterGoalIds: number[] = [];
  selectedGoalIDs: string[] = [];
  selectedRowIndex: number | null = null;
  stationName: string = '';
  arrForresult: any[] = [];
  isButtonActive: boolean = true;
  UpdateStationsArray: Array<Stations> = [];
  sortVals: boolean = false;
  enteredStation: string = '';
  stationsForSearch: Array<Stations> = [];
  userInfo: LoginModel = new LoginModel();
  stationObjToEndSession: Stations = new Stations();
  activeLicenseQty: number = 0;
  inActiveLicenseQty: number = 0;
  isFirstLoading: boolean = true;
  isFilterModalOpen: boolean = false;
  importStationList: any[] = [];
  toggleAll: boolean = false;
  isImport: boolean = true;
  isImportDisabled: boolean = false;
  fileType: string = 'XLSX';
  isInvalidImport: boolean = false;
  exportColumnsArr = [['Station Name', 'Store Name']];
  licenseList: Array<TpmLicenseModel> = [];
  currentlyAssignedToUserId: number = 0;
  currentlyAssignedToStationId: number = 0;
  isLoading: boolean = false;

  @ViewChild('importModel') importModel!: ElementRef<HTMLButtonElement>;
  @ViewChild('importStation') importStation!: ElementRef<HTMLButtonElement>;
  @ViewChild('modalConfirmCloseButton')
  modalConfirmCloseButton?: ElementRef<HTMLElement>;

  constructor(
    private permissionService: NgxPermissionsService,
    private userservice: UserserviceService,
    private masterservice: MasterDataSeriveService,
    private toastr: CustomToastsService,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private exportExcelService: ExportExcelService,
    private importService: ImportServiceService
  ) { }

  private refreshInterval: any;

  async ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Stations', link: '/admin/home/stations' },
    ]);

    this.userInfo = this.masterservice.getUserDetailsFromStorage();
    await this.getData();
    this.refreshInterval = setInterval(() => {
      if (!this.isFilterModalOpen && this.selectedStationIds.length === 0) {
      }
    }, 5000);
  }

  ngOnDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  async getData() {
    await this.getLicenses();
    await this.getStationslist();
    await this.getAllStores();
  }

  getPermissionsByUserId() {
    this.userservice.getUserRolesandPerm().then((res) => {
      let permissions = res as UserPermissionsModel[];

      let perm: string[] = [];

      permissions?.forEach((pr) => {
        perm.push(pr.name);
      });

      this.permissionService.loadPermissions(perm);
    });
  }

  getAllStores() {
    let userdata = this.masterservice.getUserDetailsFromStorage();
    let c_id: number = userdata.companyID;
    this.masterservice.getallstores(c_id).subscribe((res) => {
      if (res) {
        this.stores = res as Stores[];
      }
    });
  }

  async getLicenses() {
    try {
      const companyId = this.userInfo?.companyID;
      const res = await firstValueFrom(
        this.masterservice.getAvailableLicenses(companyId)
      );
      this.licenseList = (res as TpmLicenseModel[]) || [];
    } catch (e) {
      console.error('Error fetching licenses:', e);
    }
  }

  unassignLicense(station: Stations) {
    this.currentlyAssignedToUserId = station.currentlyAssignedToUserId;
    this.currentlyAssignedToStationId = station.stationId;
    this.stationObjToEndSession = station;
    this.stationObjToEndSession.userName = station.currentlyAssignedToUsername;
  }

  getStationslist() {
    this.isLoading=true;
    let userdata = this.masterservice.getUserDetailsFromStorage();
    let c_id = userdata.companyID;
    this.masterservice.getStationslist(c_id).subscribe((result) => {
      result = result.map((station) => {
        const isAssigned = (this.licenseList || []).find(
          (license) => license?.currentlyAssignedToId === station?.stationId
        );
        return {
          ...station,
          statusText: isAssigned ? 'Assigned' : '-',
          currentlyAssignedToUsername: isAssigned?.currentlyAssignedToUsername
            ? isAssigned.currentlyAssignedToUsername
            : '-',
          currentlyAssignedToUserId: isAssigned?.currentlyAssignedToUserId ?? 0,
        };
      });

      this.stationslist = result as Stations[];
      this.StationsArray = result as Stations[];
      this.activeLicenseQty = this.StationsArray.filter(
        (item) => item.userID > 0
      ).length;
      this.inActiveLicenseQty = this.StationsArray.filter(
        (item) => item.licenseNumber && item.userID <= 0
      ).length;

      if (this.isButtonActive) {
        this.StationsArray = this.StationsArray.filter(
          (item) => item.active === true
        );
        this.StationsArray1 = this.StationsArray;
        this.stationsForSearch = this.StationsArray;
        if (this.isFirstLoading == true && !this.isFilterModalOpen)
          this.filterGoalIds = [];
      } else {
        this.StationsArray = this.StationsArray.filter(
          (item) => item.active !== true
        );
        this.StationsArray1 = this.StationsArray;
        this.stationsForSearch = this.StationsArray;
        if (this.isFirstLoading == true && !this.isFilterModalOpen)
          this.filterGoalIds = [];
      }

      this.stationslist.map((res) => {
        res.createdDt = this.removeTimeFromDate(res.createdDt);
        this.exportList = this.stationslist
          .filter((st) => st.active)
          .map((st) => ({
            Station_Name: st.stationName,
            Store_Name: st.storeName,
            Status: st.active ? 'Active' : 'Inactive',
            Date_Created: this.removeTimeFromDateForExport(st.createdDt),
            Created_By: st.createdByUser,
          }));
      });
      if (!this.isFilterModalOpen)
        this.getseparatedataforFilters();
      if (!this.isFirstLoading) this.getFilterData();
      this.isFirstLoading = false;
      this.isLoading = false;
    });
  }

  showError(isActive: boolean) {
    if (isActive) {
      this.toastr.error('Unable to update station');
    } else {
      this.toastr.error('Station Already Exists!');
    }
  }

  showSuccess() {
    this.toastr.success('New Station has been successfully added.');
  }

  showUpdate() {
    this.toastr.success('Station has been successfully updated.');
  }

  isSelected(station: any): boolean {
    return this.selectedStationIds.includes(station.stationID);
  }

  activeTab(check: boolean) {
    this.isLoading = true;
    this.StationsArray = [];
    this.isButtonActive = check;
    this.headerCheckboxSelected = false;
    this.getStationslist();
  }

  search(e: any) {
    let query = this.enteredStation.toLowerCase();

    if (query.length > 0) {
      this.StationsArray = this.stationsForSearch.filter(
        (station) =>
          (station.stationName &&
            station.stationName.toLowerCase().includes(query)) ||
          (station.storeName &&
            station.storeName.toLowerCase().includes(query)) ||
          (station.licenseNumber &&
            station.licenseNumber.toLowerCase().includes(query)) ||
          (station.userName &&
            station.userName.toLowerCase().includes(query)) ||
          (station.createdByUser &&
            station.createdByUser.toLowerCase().includes(query)) ||
          (station.createdDt && station.createdDt.toLowerCase().includes(query))
      );
    } else {
      this.StationsArray = this.stationsForSearch;
    }
  }

  openFilterModal(modalState: string) {
    if (modalState == 'Open') {
      this.isFilterModalOpen = true;
    }

    if (modalState == 'Close') {
      this.isFilterModalOpen = false;
      this.filterGoalIds = [];
      this.StationsArrayforFilter.forEach((el) => {
        el.isSelected = false;
      });
    }
  }

  getseparatedataforFilters() {
    // Start with the original array
    const stations = this.StationsArray1;

    // Filter to keep only unique storeId entries
    const uniqueStores = stations.filter(
      (station, index, self) =>
        index === self.findIndex((s) => s.storeId === station.storeId)
    );

    // Add isSelected = false to all
    this.StationsArrayforFilter = uniqueStores.map((s) => ({
      ...s,
      isSelected: false,
    }));

    this.ArrayForStations = this.StationsArrayforFilter;

    this.getFilterData();
  }


  clearFilter(dta: any) {
    if (dta == 'store') {
      this.filterGoalIds = [];
      this.StationsArrayforFilter.forEach((el) => {
        el.isSelected = false;
      });
    }
    this.noData = false;
    this.getFilterData();
  }

  getFilterData() {
    const filteredArray = this.StationsArray1.filter((item) => {
      const storeTypeFilter =
        this.filterGoalIds.length === 0 ||
        this.filterGoalIds.includes(item.storeId);

      return storeTypeFilter;
    });

    if (this.filterGoalIds.length === 0) {
      this.noData = false;
    } else if (filteredArray.length == 0) {
      this.StationsArray = filteredArray;
      this.noData = true;
    }
    this.StationsArray = filteredArray;
    this.isFilterModalOpen = false;
  }

  selectedFilterCategory(dta: any) {
    this.filterName = dta;
    if (dta == 'store') {
      this.StationsArrayforFilter = this.StationsArray;
    }
  }

  collectFilterParameters(search: any) {
    this.StationsArrayforFilter.forEach((elements: Stations) => {
      if (this.filterName === 'store' && elements.storeId == search) {
        elements.isSelected = !elements.isSelected;
      }
    });

    if (this.filterName === 'store') {
      this.toggleFilterParameter(this.filterGoalIds, search);
    }
  }

  toggleFilterParameter(filterArray: any[], search: any) {
    const index = filterArray.indexOf(search);
    if (index !== -1) {
      filterArray.splice(index, 1);
    } else {
      filterArray.push(search);
    }
  }

  sortValues(val: any) {
    if (val == 'stationName') {
      this.sortVals = !this.sortVals;
      if (this.sortVals) {
        this.StationsArray.sort((a, b) =>
          a.stationName.localeCompare(b.stationName)
        );
      } else {
        this.StationsArray.sort((a, b) =>
          b.stationName.localeCompare(a.stationName)
        );
      }
    } else if (val == 'StoreName') {
      this.sortVals = !this.sortVals;
      if (this.sortVals) {
        this.StationsArray.sort((a, b) =>
          a.storeName.localeCompare(b.storeName)
        );
      } else {
        this.StationsArray.sort((a, b) =>
          b.storeName.localeCompare(a.storeName)
        );
      }
    }
  }

  deleteStation(deleteParameter: any | any[]) {
    if (Array.isArray(deleteParameter) || typeof deleteParameter === 'number') {
      if (typeof deleteParameter === 'number') {
        deleteParameter = [deleteParameter];
      }
      const selectedIds: string = deleteParameter.join(',');
      this.masterservice.deleteStation(selectedIds).subscribe((res) => {
        if (res) {
          const message =
            deleteParameter.length > 1
              ? 'Stations deleted successfully.'
              : 'Station deleted successfully.';
          this.toastr.success(message);
        }
        this.closeModal();
        this.uncheckSelectedCheckboxes();
        this.headerCheckboxSelected = false;
        if (this.stationsData) this.stationsData.sIsSelected = false;
        this.getStationslist();
      });
    }
  }

  uncheckSelectedCheckboxes() {
    this.selectedStationIds = [];
  }

  closeModal() {
    if (this.modalConfirmCloseButton) {
      this.modalConfirmCloseButton.nativeElement.click();
    }
  }

  toggleAllCheckboxes() {
    this.headerCheckboxSelected = !this.headerCheckboxSelected;
    if (this.headerCheckboxSelected) {
      this.stationsData.sIsSelected = true;
      this.selectedStationIds = this.stationslist.map((st) =>
        st.stationId.toString()
      );
      this.stationName = this.stationslist
        .filter((st) =>
          this.isButtonActive == true ? st.active == true : st.active == false
        )
        .map((st) => st.stationName)
        .toString();
    } else {
      this.selectedStationIds = [];
      this.stationsData.sIsSelected = false;
      this.stationName = '';
    }
  }

  sIsSelected(st: any): boolean {
    return this.selectedStationIds.includes(st.stationID.toString());
  }

  getActiveStatus() {
    if (this.activeStatus) {
      this.activeColor = '#aab6bc';
      this.inActiveColor = '#1e5a7d';
    } else {
      this.activeColor = '#1e5a7d';
      this.inActiveColor = '#aab6bc';
    }
  }

  createNew() {
    this.arrForresult = [];
    this.frmText = 'Add New Station';
    this.stationsData = new Stations();
  }

  getStationUserData(data: Stations) {
    this.stationObjToEndSession = data;
  }

  endUserSession() {
    if (this.currentlyAssignedToUserId == 0) return;
    const user = this.masterservice.getUserDetailsFromStorage();
    let unassignRequest = {
      assignedToUserId: Number(this.currentlyAssignedToUserId),
      assignedToId: Number(this.currentlyAssignedToStationId),
      // AB#13334: an admin ending someone else's session has no way to know
      // that user's session id, and genuinely means "end all of them".
      releaseAllSessions: true
    };
    this.masterservice
      .unassignStationLicense(unassignRequest, user?.companyID || 0)
      .subscribe((res: any) => {
        this.toastr.success(res.message);
        this.getData();
      });
  }

  getStation(id: number) {
    const station = this.stationslist.find((s: Stations) => s.stationId === id);

    if (station) {
      this.stationName = station.stationName;
      this.stationsData = { ...station, licenseID: station.licenseID ?? 0 };
    }
  }

  getStationByIdforUpdate(data: Stations) {
    this.frmText = 'Update Station';
    this.isUpdated = true;
    this.stationName = data.stationName;
    this.stationsData = { ...data };
    this.stationsData.licenseID =
      this.stationsData.licenseID == null ? 0 : this.stationsData.licenseID;
  }

  addstation(data: Stations) {
    let userdata: any = this.masterservice.getUserDetailsFromStorage();
    data.companyId = userdata.companyID;
    data.createdUserId = userdata.userId;
    data.lastChangedDt = userdata.userId;
    this.masterservice.addStation(data).subscribe(
      (res) => {
        if (res) {
          this.getStationslist();
        }
        if (this.isUpdated == true) {
          this.showUpdate();
          this.isUpdated = false;
        } else {
          this.showSuccess();
        }
      },
      (error) => {
        console.error('Error:', error);

        if (data.active == false) {
          this.showError(true);
        } else {
          this.showError(false);
        }
      }
    );
  }

  //#region Stations import export and Download template
  DownloadStationTemplate() {
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([
      this.exportColumnsArr[0],
    ]);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Stations');
    const wbout: Blob = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    FileSaver.saveAs(new Blob([wbout]), 'stations.xlsx');
  }

  exportToExcel(): void {
    this.exportExcelService.exportAsExcelFile(this.exportList, 'Stations-data');
  }

  async openConfirmPopup(stationId: any) {
    this.getStation(stationId);
    if (stationId === null) {
      this.deleteButtonClickedWithoutSelection = true;
      this.deleteButtonClickedWithSelection = false;
    } else if (Array.isArray(stationId) && stationId.length === 0) {
      this.deleteButtonClickedWithoutSelection = true;
      this.deleteButtonClickedWithSelection = false;
    } else {
      this.deleteButtonClickedWithoutSelection = false;
      this.deleteButtonClickedWithSelection = true;
      this.deleteParameter = stationId;
    }
  }

  handleCheckboxChange(event: Event, stationId: any): void {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      if (!this.selectedStationIds.includes(stationId)) {
        this.selectedStationIds.push(stationId);
      }
    } else {
      const index = this.selectedStationIds.indexOf(stationId);
      if (index !== -1) {
        this.selectedStationIds.splice(index, 1);
      }
    }

    this.stationName = this.getActiveSelectedStationNames();
  }

  getActiveSelectedStationNames(): string {
    let stationsData = this.stationslist.filter(
      (st) => st.active === this.isButtonActive && st.sIsSelected == true
    );

    return stationsData.map((st) => st.stationName).join(', ');
  }

  removeTimeFromDateForExport(dateString: string): string {
    const dateWithoutTime = new Date(dateString);
    const day = dateWithoutTime.getDate();
    const month = dateWithoutTime.getMonth() + 1;
    const year = dateWithoutTime.getFullYear();

    // Pad day and month with leading zeros if needed
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    // Create the formatted date string
    const formattedDate = `${formattedMonth}-${formattedDay}-${year}`;
    return formattedDate;
  }

  removeTimeFromDate(dateString: string) {
    const parts = dateString.split(' ');
    const datePart = parts[0];
    return datePart;
  }

  importStations() {
    this.isImportDisabled = false;

    if (this.importStation) {
      this.importStation.nativeElement.click();
    }
  }

  onFileChangeImport(event: any) {
    let user = this.masterservice.getUserDetailsFromStorage();
    let outletID = JSON.parse(localStorage.getItem('storeId')!);
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const rawData: any[][] = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
        }) as any[][];

        const filteredData = rawData.filter((row) =>
          row.some((cell) => cell !== null && cell !== undefined && cell !== '')
        );

        this.importStationList = await this.transformToJsonArray(filteredData);

        this.importStationList.forEach((item) => {
          item.createdByUserID = user.userId;
          item.companyID = this.userInfo.companyID;
          item.outletID = outletID;
          item.isChecked = false;
          item.addStatus = 2;
          item.status = null;
        });
      };

      reader.readAsBinaryString(file);
      if (this.importModel) this.importModel.nativeElement.click();
    }
  }

  transformToJsonArray(data: any[][]): any[] {
    if (data.length === 0) return [];

    const headerMapping: { [key: string]: string } = {
      'Station Name': 'stationName',
      License: 'License',
      'Store Name': 'storeName',
    };

    const headers = data[0];
    const camelCaseHeaders = headers.map(
      (header) =>
        headerMapping[header] || header.toLowerCase().replace(/\s+/g, '')
    );

    const rows = data.slice(1);
    return rows.map((row) => {
      const obj: any = {};
      camelCaseHeaders.forEach((header, index) => {
        obj[header] = row[index];
      });
      return obj as any;
    });
  }

  checkAllImport(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.toggleAll = inputElement.checked;
    this.importStationList.forEach((item) => {
      if (item.addStatus == 2) {
        item.isChecked = inputElement.checked;
      }
    });
    this.isImportEnabled();
  }

  isImportEnabled(): void {
    let list = this.importStationList.filter((user) => user.isChecked == true);
    this.isImport = list.length > 0;
  }

  closeImportModal(): void {
    const fileInput = this.importStation.nativeElement;
    fileInput.value = '';
  }

  addImportedStations() {
    this.isInvalidImport = false;
    let stationList = this.importStationList
      .filter((user) => user.isChecked == true)
      .map(({ status, ...rest }) => rest);

    if (stationList.length == 0) {
      this.toastr.error('Invalid Selection');
      return;
    }

    stationList.forEach((station) => {
      if (
        station.stationName == undefined &&
        station.liecence == undefined &&
        station.storeName == undefined
      ) {
        this.toastr.error('Invalid entry in import file');
        this.isInvalidImport = true;
        return;
      }
    });

    if (this.isInvalidImport) {
      return;
    }

    stationList.forEach((station) => {
      station.active = true;
    });

    this.importService.ImportStoreStations(stationList).subscribe((res) => {
      this.importStationList = res as any[];
      this.importStationList.forEach((user) => {
        if (user.reason != null) {
          user.reason = user.reason
            .split(',')
            .map((reason: string) => reason.trim())
            .filter((reason: string | any[]) => reason.length > 0);
        }
      });
      this.isImportDisabled = true;
      this.toggleAll = false;
      this.getStationslist();
    });
  }

  getRemainingErrors(reasonString: string): string {
    const errors = reasonString.split('|');
    return errors.slice(1).join('\n');
  }

  //#endregion
}
